import styled from 'styled-components';

export const StyledOutletBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }): string => theme.spacing_unit_x2};
`;
